import { render, staticRenderFns } from "./MemberClubs.vue?vue&type=template&id=0c9ee060&"
import script from "./MemberClubs.vue?vue&type=script&lang=ts&"
export * from "./MemberClubs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports